package com.crowpay

import com.lightningkite.UUID
import com.lightningkite.lightningdb.Condition
import com.lightningkite.lightningdb.HasId
import kotlinx.serialization.Serializable


interface HasReadBy {
    val readBy: Set<UUID>
}

interface ReadByDataModel: HasReadBy, HasId<UUID>

interface HasReadByEndpoints<T : ReadByDataModel> {
    suspend fun markAsRead(input: List<UUID>): List<T>
    suspend fun markAsUnread(input: List<UUID>): List<T>
}

interface ReadByWithFeedbackDataModel : ReadByDataModel {
    val feedback: AccessAndFeedback?
}

interface HasReadByWithFeedbackEndpoints<T : ReadByWithFeedbackDataModel> : HasReadByEndpoints<T> {
    suspend fun markFeedbackAsRead(input: List<UUID>): List<T>
    suspend fun markFeedbackAsUnread(input: List<UUID>): List<T>
}

interface ReadByWithCreditsDataModel : ReadByDataModel {
    val credits: List<Credit>
}

@Serializable
data class MarkCreditsRead(
    val itemIds: List<UUID>,
    val additionalCondition: Condition<Credit>? = null
)

interface HasReadByWithCreditsEndpoints<T : ReadByWithCreditsDataModel> : HasReadByEndpoints<T> {
    suspend fun markCreditsAsRead(input: MarkCreditsRead): List<T>
    suspend fun markCreditsAsUnread(input: MarkCreditsRead): List<T>
}